import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseSearchCriteria } from '../../../models/searchCriteria/BaseSearchCriteria';
import { CommonModule } from '@angular/common';
import { TooltipDirective } from '../../../utils/tooltip.directive';

@Component({
  selector: '[app-th-ordering]',
  standalone: true,
  imports: [CommonModule, TooltipDirective],
  templateUrl: './th-ordering.component.html',
  styleUrl: './th-ordering.component.scss',
})
export class ThOrderingComponent {
  @Input()
  colName?: string;

  @Input()
  colValue?: string;

  @Input()
  baseSearchCriteria!: BaseSearchCriteria;

  @Output()
  orderingClick = new EventEmitter<BaseSearchCriteria | undefined>();

  ordering(field: string | undefined) {
    if (this.baseSearchCriteria) {
      if (this.baseSearchCriteria.orderBy === field) {

        this.baseSearchCriteria.descOrder =
          (this.baseSearchCriteria.descOrder != undefined && this.baseSearchCriteria.descOrder === false)
            ? true
            : (this.baseSearchCriteria.descOrder != undefined &&  this.baseSearchCriteria.descOrder === true)
            ? undefined
            : false;
      } else {
        this.baseSearchCriteria.orderBy = field;
        this.baseSearchCriteria.descOrder = false;
      }
    }
    this.orderingClick.emit(this.baseSearchCriteria);
  }
}
